import VueRouter from "vue-router";
import Vue from "vue";
import Dashboard from "src/components/dashboard/Dashboard.vue";
import Contact from "src/components/contact/Contact.vue";
import Account from "src/components/account/Account.vue";
import Mag from "src/components/mag/Mag.vue";
import MagArticle from "src/components/mag/MagArticle.vue";
import LinkedContent from "src/components/linked-content/LinkedContent.vue";
import ConventionList from "src/components/convention/ConventionList.vue";
import Panorama from "src/components/convention/vision-panorama/Panorama.vue";
import Cgu from "src/components/cgu/Cgu.vue";
import Convention from "src/components/convention/Convention.vue";
import ConventionPresentation from "src/components/convention/presentation/ConventionPresentation.vue";
import ConventionCA from "src/components/convention/ca/ConventionCa.vue";
import ConventionObligationsDispatch from "src/components/convention/obligations/ConventionObligationsDispatch.vue";
import ConventionCompactInfo from "src/components/convention/compact-info/ConventionCompactInfo.vue";
import ConventionSectionPrint from "src/components/convention/section-print/ConventionSectionPrint.vue";
import Private from "src/pages/private/Private.vue";
import Auth from "src/pages/auth/Auth.vue";
import AuthLogin from "src/components/auth/AuthLogin.vue";
import AuthFirstConnexion from "src/components/auth/AuthFirstConnexion.vue";
import AuthForgotPassword from "src/components/auth/AuthForgotPassword.vue";
import AuthResetPassword from "src/components/auth/AuthResetPassword.vue";
import AuthSSO from "src/components/auth/AuthSSO.vue";
import AuthError from "src/components/auth/AuthError.vue";

const routes = [
    {
        name: "auth",
        path: "/auth",
        meta: {
            type: "auth",
            title: "Connectez-vous",
        },
        component: Auth,
        children: [
            {
                name: "login",
                path: "/",
                component: AuthLogin,
                meta: {
                    title: "Connectez-vous",
                },
            },
            {
                name: "first-connexion",
                path: "first-connexion",
                component: AuthFirstConnexion,
                meta: {
                    title: "Première Connexion",
                },
            },
            {
                name: "forgot-password",
                path: "forgot-password",
                component: AuthForgotPassword,
                meta: {
                    title: "Mot De Passe Oublié",
                },
            },
            {
                name: "reset-password",
                path: "reset-password",
                component: AuthResetPassword,
                meta: {
                    title: "Réinitialiser le mot de passe",
                },
            },
            {
                name: "sso",
                path: "sso-redirect",
                component: AuthSSO,
                meta: {
                    title: "SSO Redirect",
                },
            },
            {
                name: "error",
                path: "error",
                component: AuthError,
                meta: {
                    title: "Error",
                },
            },
            {
                path: "*",
                redirect: "/auth",
            },
        ],
    },
    {
        name: "espace-client",
        path: "/espace-client",
        component: Private,
        redirect: { name: "accueil" },
        meta: {
            type: "espace-client",
            title: "Espace Client",
        },
        children: [
            {
                name: "accueil",
                path: "accueil",
                component: Dashboard,
                meta: {
                    title: "Accueil",
                },
            },
            {
                name: "cgu",
                path: "cgu",
                component: Cgu,
            },
            {
                path: "mon-compte",
                component: Account,
                name: "account",
                meta: {
                    title: "Mon Compte",
                },
            },
            {
                name: "mag",
                path: "mag",
                component: Mag,
                meta: {
                    title: "Magazine",
                },
            },
            {
                path: "mag/:slugOrContentId",
                name: "article",
                meta: {
                    type: "article",
                    title: "Article",
                },
                component: MagArticle,
            },
            {
                name: "linked-content",
                path: "contenus-lies/:id",
                component: LinkedContent,
                meta: {
                    title: "Contenus liés",
                },
            },
            {
                name: "cc",
                path: "conventions-collectives",
                component: ConventionList,
                meta: {
                    title: "Recherche",
                },
            },
            {
                name: "conventions-panorama",
                path: "panorama",
                component: Panorama,
                meta: {
                    title: "Panorama des conventions",
                },
            },
            {
                name: "contact",
                path: "contact",
                component: Contact,
                meta: {
                    title: "Contact",
                },
            },
            {
                name: "convention",
                path: "conventions-collectives/:conventionId/:variantNumber",
                component: Convention,
                redirect: "conventions-collectives/:conventionId/:variantNumber/presentation",
                meta: {
                    type: "convention",
                },
                children: [
                    {
                        name: "convention-presentation",
                        path: "presentation",
                        component: ConventionPresentation,
                        meta: {
                            title: "Presentation",
                        },
                    },
                    {
                        name: "convention-champ-dapplication",
                        path: "champ-dapplication",
                        component: ConventionCA,
                        meta: {
                            title: "Champ d'application",
                        },
                    },
                    {
                        name: "convention-obligations",
                        path: "obligations",
                        component: ConventionObligationsDispatch,
                        meta: {
                            title: "Obligations",
                        },
                        children: [
                            {
                                name: "convention-obligations-slug",
                                path: ":slug(.*)",
                            },
                        ],
                    },
                    {
                        name: "convention-compact-info",
                        path: "compact-info",
                        component: ConventionCompactInfo,
                        meta: {
                            title: "Informations compactées",
                        },
                    },
                    {
                        name: "convention-section-print",
                        path: "print/:sectionKey",
                        component: ConventionSectionPrint,
                        meta: {
                            title: "Print",
                        },
                    },
                ],
            },
        ],
    },
];

const router = new VueRouter({
    mode: "history",
    routes,
});

router.beforeEach((to, from, next) => {
    const currentPath = to.fullPath;
    if (/\/linked.*/.test(currentPath)) {
        /* eslint-disable no-useless-escape */
        const params = currentPath.match(/\/linked\/([^\/#?]+)/is);
        const format = to.query.format;
        if (format === "article") {
            next(`/espace-client/mag/${params[1]}`);
        } else {
            next(`/espace-client/contenus-lies/${params[1]}`);
        }
    } else if (/\/ccn.*/.test(currentPath)) {
        const params = currentPath.match(/\/ccn\/(.*?)\/d(\d+)\/?(ca|pres|ob)?(?:#?)(.*)/is);
        const conventionId = params[1];
        const variantNumber = params[2];
        const tab = params[3];
        const slug = params[4];
        if (tab == "ob") {
            next(`/espace-client/conventions-collectives/${conventionId}/${variantNumber}/obligations/${slug}`);
        } else if (tab == "ca") {
            next(`/espace-client/conventions-collectives/${conventionId}/${variantNumber}/champ-dapplication`);
        } else {
            next(`/espace-client/conventions-collectives/${conventionId}/${variantNumber}/presentation`);
        }
    } else if (/\/documents.*/.test(currentPath)) {
        const wpApiUrl = window.location.host.includes("staging")
            ? window.process.env.APP_DIODE_WP_STAGING_BASE_URL
            : window.process.env.APP_DIODE_WP_LIVE_BASE_URL;
        /* eslint-disable no-useless-escape */
        const params = currentPath.match(/documents\/([^\/]+\.pdf)/is);
        window.location.href = `${wpApiUrl}/documents/${params[1]}`;
    } else {
        next(); // Allow the navigation if no conditions are matched
    }
});

const DEFAULT_TITLE = "AG2R La Mondiale, Diode";
router.afterEach(to => {
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

export default router;
